/**Dependencies */
import React from "react";

/**Components */
import { Button, Modal } from "react-bootstrap";

import openpay from "../images/openpay.png";

export const ModalTerminos = ({ openModal, setOpenModal }) => {
  return (
    <>
      <Modal
        size="lg"
        show={openModal}
        onHide={() => setOpenModal}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            Políticas de Privacidad y Cancelación
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="text-rose">LICENCIA</h4>
          <p style={{ textAlign: "justify", fontSize: "16px" }}>
            Por virtud de la celebración de este convenio, "International Travel
            Net” otorga y concede al usuario el derecho no exclusivo, revocable
            y no transferible de ver y utilizar el sitio web
            www.internationaltravelnet.com.mx de conformidad con los Términos y
            Condiciones de uso que aquí se estipulan. Para los efectos del
            presente convenio, las partes acuerdan que por «usuario» se
            entenderá a cualquier persona de cualquier naturaleza que ingrese al
            sitio web www.internationaltravelnet.com.mx y/o a cualquiera de las
            subpáginas que despliegan su contenido y/o a la persona de cualquier
            naturaleza que se dé de alta y/o use cualquiera de los servicios que
            se ofrecen a través de dicha página.
          </p>
          <br />
          <h4 className="text-rose">CONDICIONES DEL SERVICIO</h4>
          <br />
          <h5 className="text-rose">Condiciones de Entrega</h5>
          <p style={{ textAlign: "justify", fontSize: "16px" }}>
            Una vez que el cliente cubra el anticipo o 100% del pago de su
            paquete vacacional recibirá vía correo electrónico el comprobante
            del mismo según sea el caso y clave de reservación que ampare su
            estancia en el hotel, destino y fecha seleccionada.
          </p>
          <br />
          <h5 className="text-rose">Condiciones del Hotel</h5>
          <p style={{ textAlign: "justify", fontSize: "16px" }}>
            Al confirmar la reserva, el cliente conoce y acepta que por motivos
            de los lineamientos oficiales derivados de la situación actual el
            hotel puede modificar y adaptar los horarios y servicios en función
            de las necesidades de cada momento. Así mismo el cliente se
            compromete a cumplir con las normas oficiales y reglamento interior
            del hotel en todo momento para cumplir con la normativa establecidos
            por la situación actual, dejando a la discrecionalidad de la
            dirección del Hotel la cancelación de la estancia en caso de
            incumplimiento. Así mismo el hotel puede hacer uso del derecho de
            admisión con base en los lineamientos oficiales.
          </p>
          <br />
          <h5 className="text-rose">Cambio de Fechas</h5>
          <p style={{ textAlign: "justify", fontSize: "16px" }}>
            El cliente podrá solicitar cambio de fechas, hotel o destino de
            manera ilimitada durante todo el año 2023 siempre y cuando notifique
            por escrito al correo: contacto@internationaltravelnet.com con un
            mínimo de 25 días hábiles de antelación y si aplica a su
            reservación. Es indispensable señalar que, en el caso de existir un
            cambio de tarifa con la nueva fecha, hotel o destino solicitado,
            esta diferencia deberá de ser cubierta por el cliente en su
            totalidad, al momento de realizar la actualización de fecha, destino
            u hotel para poder ser aceptada. Así como se quedan sujetos a los
            términos y condiciones con el operador/aerolínea/hotel con el cual
            que se haya ingresado a la reserva.
          </p>
          <br />
          <h5 className="text-rose">Devoluciones y/o Cancelaciones</h5>
          <p style={{ textAlign: "justify", fontSize: "16px" }}>
            El cliente podrá solicitar la devolución del importe pagado siempre
            y cuando la reserva se encuentre dentro de las condiciones para
            reembolso, y sea con un mínimo de 25 días antes de su entrada, así
            como, este 100% pagada (no hay reembolsos en sistemas de apartado),
            y siempre sujetándonos a los términos y condiciones, de la tarifa
            contratada, según el hotel y operador correspondiente, por lo que,
            deberá, notificar al correo: contacto@internationaltravelnet.com con
            al menos 25 días hábiles de antelación a la fecha de su llegada al
            hotel, en este caso el cliente podrá elegir según sus intereses
            aplicar el 100% de la devolución como crédito disponible a su favor
            para ser usado en su próximo viaje durante los próximos 12 meses
            posteriores a la fecha de solicitud o la cancelación del mismo bajo
            las siguientes condiciones:
            <br />
            <br />
            Dar aviso por escrito al correo: contacto@internationaltravelnet.com
            con al menos 25 días hábiles de antelación a su llegada al hotel
            seleccionado, en dicho caso habrá una penalización del 30% del
            importe pagado por gastos administrativos.
            <br />
            <br />
            <ul>
              <li>
                Con 15 días hábiles de antelación con una penalidad de 50% de lo
                pagado.
              </li>
              <li>
                Con 15 días hábiles de antelación con una penalidad de 50% de lo
                pagado.
              </li>
            </ul>
          </p>
          <br />
          <p
            className="text-rose"
            style={{ textAlign: "justify", fontSize: "16px" }}
          >
            *ES IMPORTANTE SEÑALAR QUE SI LA RESERVACIÓN FUE HECHA DESDE SU
            INICIO CON UNA TARIFA PUBLICADA COMO “NO REEMBOLSABLE” EL CLIENTE
            ACEPTA QUE NO HAY CAMBIOS NI DEVOLUCIONES BAJO NINGUNA
            CIRCUNSTANCIA*
          </p>
          <br />
          <h4 className="text-rose">FORMAS DE PAGO</h4>
          <br />
          <p style={{ textAlign: "justify", fontSize: "16px" }}>
            Para pagos realizados por medio de tarjetas de crédito y débito se
            generará un CARGO EXTRA del 3.5% sobre el total de su compra,
            nuestro sistema validará las transacciones por medio de sistemas de
            seguridad vigilados por instituciones bancarias. Los pagos se
            procesan en un tiempo estimado de 24 horas después de su compra, por
            tal motivo, los pedidos que hayan sido pagados con tarjeta de
            crédito/ débito y el Cliente decida recoger su cupón de servicios en
            nuestra oficina, se entregará después de 1 día hábil (indica un
            horario entre 9:00a.m a 7:30p.m), o en su caso se le enviará de
            manera electrónica. Para una mejor experiencia de compra con tarjeta
            de crédito en nuestra tienda en línea, el titular de la tarjeta
            deberá estar inscrito en los programas de compras seguras con 3D
            Secure para Visa y/o Master Card.
          </p>
          <br />
          <p
            style={{ textAlign: "justify", fontSize: "16px" }}
            className="text-rose"
          >
            *TARIFAS SUJETAS A CAMBIO Y DISPONIBILIDAD SIN PREVIO AVISO*
          </p>
          <p style={{ fontSize: "17px" }}>
            ¡Aceptamos todas las formas de pago! Efectivo, tarjetas de crédito y
            débito, transferencias y pagos digitales. ¡Elige la que te acomoda!”
            “Aceptamos todas las formas de pago. Su transacción se realiza de
            manera segura a través de Openpay, garantizando la confidencialidad
            y protección de sus datos.”
          </p>
          <img src={openpay} width={200} alt="" />
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-purple w-auto"
            onClick={() => setOpenModal(false)}
            style={{ fontSize: "14px" }}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
